<template>
  <span v-if="currentRouteName === 'Perangkat'">
    <router-link to="/perangkat/internal" class="btn btn-success mx-1"
      >Perangkat Internal</router-link
    >
    <router-link to="/perangkat/postel" class="btn btn-success mx-1"
      >Perangkat Postel</router-link
    >
    <router-link to="/perangkat/download-postel" class="btn btn-success mx-1"
      >Perangkat Kominfo</router-link
    >
  </span>
  <span>
    <router-view></router-view>
  </span>
</template>

<script>
export default {
  name: "Perangkat-Index",
  computed: {
    currentRouteName() {
      const path = this.$route.name;
      const pathing = path
        .split("/")
        .filter(function (e) {
          return e;
        })
        .join(" / ");
      return pathing;
    },
  },
};
</script>